const WeekendWorkingOptions = ["Yes", "No"];

export const getEditShiftJson = (data) => {
  const EditShiftForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          // Row 1: Start Time, End Time
          [
            {
              id: 2,
              label: "Start Time",
              type: "time",
              name: "startTime",
              Placeholder: "Start Time",
              value: data["startTime"],
              validationRules: [
                {
                  required: true,
                  message: `Start Time is required`,
                },
              ],
            },
            {
              id: 3,
              label: "End Time",
              type: "time",
              name: "endTime",
              Placeholder: "End Time",
              value: data["endTime"],
              validationRules: [
                {
                  required: true,
                  message: `End Time is required`,
                },
              ],
            },
          ],
          // Row 2: Weekend Working
          [
            {
              id: 4,
              label: "Weekend Working",
              type: "radio",
              name: "weekendWorking",
              Placeholder: "Select",
              value: "",
              options: WeekendWorkingOptions,
              validationRules: [
                {
                  required: true,
                  message: `Weekend Working is required`,
                },
              ],
            },
          ],
          // Row 3: Check-In / Check-Out Buffer Time
          [
            {
              id: 5,
              label: "Check-In Buffer Time (mins)",
              type: "duration",
              name: "checkinBufferTime",
              Placeholder: "Check-In Buffer Time",
              value: data["checkinBufferTime"],
              validationRules: [
                {
                  required: true,
                  message: `Check-In Buffer Time is required`,
                },
              ],
            },
            {
              id: 6,
              label: "Check-Out Buffer Time (mins)",
              type: "duration",
              name: "checkoutBufferTime",
              Placeholder: "Check-Out Buffer Time",
              value: data["checkoutBufferTime"],
              validationRules: [
                {
                  required: true,
                  message: `Check-Out Buffer Time is required`,
                },
              ],
            },
          ],
        ],
      },
    ],
  };

  return {
    EditShiftForm,
  };
};
